module.exports = __webpack_public_path__ + "static/7-insights-2-edc9d9459492b2d31af11ed91a7db6fa.jpg";